import React from 'react';

import { FilterField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { formatNotFoundError } from '@utils';
import { FILTER_TYPE } from '@api/filters/constants';

const RelatedFundamentalSkillModal = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add related fundamental skill"
    okText="ADD FUNDAMENTAL SKILL"
    onSubmit={({ entity }) => onSubmit(entity)}
  >
    <FilterField
      name="entity"
      label="Choose a fundamental skill"
      queryVariables={{ typeId: FILTER_TYPE.FUNDAMENTAL_SKILL.id }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Fundamental skill is required' }]}
    />
  </RelatedContentModal>
);

const Item = (entity) => {
  if (entity instanceof Error) {
    const error = entity;
    return <InfoItem>{formatNotFoundError({ error })}</InfoItem>;
  }

  return <InfoItem>{entity.title}</InfoItem>;
};

RelatedFundamentalSkillModal.Item = Item;

export default RelatedFundamentalSkillModal;
